import React, { useState } from 'react';
import { getYouTubeVideoId } from '../utils/machines';

const FaqsView = () => {
  const zones = [
    { id: 1, category: 'LOCKER', label: 'Taquilla', x: '40%', y: '18%',           video_x: '-58%', video_y: '20%', url: 'https://www.youtube.com/watch?v=IG41no2zIoM' },
    { id: 2, category: 'SCREEN', label: 'Pantalla', x: '31%', y: '32%',           video_x: '-58%', video_y: '50%', url: 'https://www.youtube.com/watch?v=IG41no2zIoM' },
    { id: 3, category: 'DOOR', label: 'Puerta', x: '31%', y: '45%',               video_x: '-58%', video_y: '80%', url: 'https://www.youtube.com/watch?v=IG41no2zIoM' },
    { id: 4, category: 'TICKET', label: 'Ticket', x: '50%', y: '44%',             video_x: '90%',  video_y: '20%', url: 'https://www.youtube.com/watch?v=IG41no2zIoM' },
    { id: 5, category: 'PAYMENTS', label: 'Pago con tarjeta', x: '70%', y: '44%', video_x: '90%',  video_y: '80%', url: 'https://www.youtube.com/watch?v=IG41no2zIoM' },
  ];

  const categories = Array.from(new Set(zones.map(z => z.category)));
  const [activeCategories, setActiveCategories] = useState(new Set(categories));

  const toggleCategory = (category) => {
    const newSet = new Set(activeCategories);
    if (newSet.has(category)) {
      newSet.delete(category);
    } else {
      newSet.add(category);
    }
    setActiveCategories(newSet);
  };

  return (
    <div style={{ display: 'flex' }}>
      {/* Sidebar Menu */}
      <div style={{ width: '300px', padding: '10px' }}>
        <h1 className="mt-5 mb-3 text-vw-dark">FAQS VIDEOS</h1>
        <h3 className="mt-3 mb-5 text-vw-light">Selecciona una categoria para ver los video-manuales que incluye.</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => toggleCategory(cat)}
              style={{
                padding: '10px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: activeCategories.has(cat) ? '#001d3a' : '#e0e0e0',
                color: activeCategories.has(cat) ? 'white' : 'black',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Machine Image + Zones */}
      <div className="machine-container" style={{ position: 'relative', flex: 1 }}>
        <img src="/images/machines/big.png" alt="Machine" style={{ width: '100%' }} />

        {zones.filter(z => activeCategories.has(z.category)).map(zone => {
          const videoId = getYouTubeVideoId(zone.url);

          return (
            <div key={zone.id}>
              {/* Zone Dot */}
              <div
                className="zone-dot"
                style={{ top: zone.y, left: zone.x, transform: 'translate(-50%, -50%)' }}
              />

              {/* Connector Line */}
              <svg
                className="connector-line"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              >
                <line
                  x1={zone.x}
                  y1={zone.y}
                  x2={zone.video_x}
                  y2={zone.video_y}
                  stroke="#ffae00"
                  strokeWidth="2"
                />
              </svg>

              {/* Video Container */}
              <div
                className="video-container"
                style={{
                  position: 'absolute',
                  top: zone.video_y,
                  left: zone.video_x,
                  transform: 'translateY(-50%)',
                  background: '#fff',
                  border: '1px solid #ccc',
                  padding: '10px',
                  width: '320px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  zIndex: 20,
                }}
              >
                <div style={{ marginBottom: '8px', fontWeight: 'bold', color: '#000' }}>{zone.label}</div>
                <iframe
                  width="100%"
                  height="180"
                  src={`https://www.youtube.com/embed/${videoId}`}
                  allowFullScreen
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FaqsView;
